export const Colors={
    purple:'#753cbe',
    white:'#ffffff',
    gray1:'#f5f5f5',
    gray2:'#ebebeb',
    gray3:'#f1f1f1',
    azure: '#1fb9ee',
}
